import React from 'react';
import fetch from '../../fetch';
import utils from '../../../utils';
import {Progress} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    // {type: 'selection'},
    {key:'$index', label: '序号' , width : 80},
    {key:'orgName', label: '部门名称',width : 120},
    {key:'majorName', label: '专业名称' ,width : 120},
    {key:'classesName', label: '班级名称' ,width : 120},
    {key:'studentName', label: '学生姓名' ,width : 120},
    {key:'graduationGrade', label: '届别' ,width : 120},
    {key:'employeeName', label: '指导教师' ,width : 120},
    {key:'title', label: '论文题目' ,width : 120},
    {key:'progress', label: '录入进度' ,width : 120, render:(val)=>{
                return  <Progress percent={val==null?0:val} />
            }},
    {key:'termName', label: '学期' ,width : 120},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/graduation/employeeresult/query?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const getDetailById = (id)=> {
    return fetch.get(`graduation/result/getDetailById/${id}`)
}

const remove = (ids) => {
    return fetch.post('graduation/result/delete' , ids)
}

const update = (data) => {
    return fetch.post('graduation/result/update/'+data.id , data)
}

export default {
    columns,
    onSelect,
    setRefresh,
    getSelection,
    querySearch ,
    getDetailById,
    delete : remove,
    update,
    download : `${fetch.base}graduation/result/file/download/`
}

